import SimpleVast from '../index';
import { isHttpUrl } from '../lib';

export function playCompanionAd(creative) {
  creative.variations.forEach((variation) => {
    const openClickThrough = () => {
      if (isHttpUrl(variation.companionClickThroughURLTemplate)) {
        window.open(variation.companionClickThroughURLTemplate, '_blank');
      }
      this.companionVastTracker.click(null, this.macros);
    };

    const mount = (container) => {
      this.companionVastTracker.trackImpression(this.macros);
      this.domElements.push(container);
      if (variation.adSlotID) {
        const slot = document.getElementById(variation.adSlotID);
        if (slot) { slot.appendChild(container); return; }
      }
      this.video.parentElement.appendChild(container);
    };

    if (variation.staticResources && variation.staticResources.length > 0) {
      variation.staticResources.forEach((staticResource) => {
        const container = document.createElement('div');
        SimpleVast.applyNonLinearCommonDomStyle(container);

        const img = document.createElement('img');
        img.src = staticResource.url;
        img.addEventListener('click', openClickThrough);
        container.appendChild(img);
        mount(container);
      });
    }

    // HTMLResources are not rendered: inserted as markup, the ad's scripts would run in this
    // page's origin.

    if (variation.iframeResources && variation.iframeResources.length > 0) {
      variation.iframeResources.filter(isHttpUrl).forEach((src) => {
        const container = document.createElement('iframe');
        SimpleVast.applyNonLinearCommonDomStyle(container);
        container.src = src;
        container.addEventListener('click', openClickThrough);
        mount(container);
      });
    }
  });
}
